class FiltersPanel extends Panel {
  transitionFrom(previousState, newState, triggerElement, previousPanel) {
    //super.transitionFrom(previousState, newState, triggerElement, previousPanel);
    this.activate();
    if (previousState === 'idle') {
      actions.openRightFullNav().then(() => {
        window.trapFocus(this, this.defaultFocus, triggerElement);
      });
    }
  }

  connectedCallback() {
    super.connectedCallback();

    this.querySelector('[results-count]')?.addEventListener('click', (ev) => {
      setTimeout(() => {
        document.querySelector('#product-grid product-card')?.focus();
      }, 532);
    });
  }
}
customElements.define('filters-panel', FiltersPanel);
